import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom"

import { AuthLayout } from "@/components/auth/auth-layout"
import { CustomerRoute } from "@/auth/CustomerRoute"
import { ProtectedRoute } from "@/auth/ProtectedRoute"
import { AuthFlowPage } from "@/pages/AuthFlowPage"
import { HomePage } from "@/pages/HomePage"
import { RestorePasswordPage } from "@/pages/RestorePasswordPage"
import { AdvancePayPage } from "@/pages/AdvancePayPage"
import { InvoicesPage } from "@/pages/InvoicesPage"
import { RentPage } from "@/pages/RentPage"
import { PaymentDonePage } from "@/pages/PaymentDonePage"
import { PaymentPage } from "@/pages/PaymentPage"

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<AuthFlowPage />} />
          <Route path="/select-customer" element={<AuthFlowPage />} />
          <Route path="/restore-password/:token" element={<RestorePasswordPage />} />
        </Route>
        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <CustomerRoute>
                <HomePage />
              </CustomerRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/advance-pay"
          element={
            <ProtectedRoute>
              <CustomerRoute>
                <AdvancePayPage />
              </CustomerRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/invoices"
          element={
            <ProtectedRoute>
              <CustomerRoute>
                <InvoicesPage />
              </CustomerRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/invoices/:contractId"
          element={
            <ProtectedRoute>
              <CustomerRoute>
                <InvoicesPage />
              </CustomerRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/payments"
          element={
            <ProtectedRoute>
              <CustomerRoute>
                <PaymentPage />
              </CustomerRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/payments/done"
          element={
            <ProtectedRoute>
              <CustomerRoute>
                <PaymentDonePage />
              </CustomerRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/rent"
          element={
            /* <ProtectedRoute>
              <CustomerRoute> */
                <RentPage />
              /* </CustomerRoute>
            </ProtectedRoute> */
          }
        />
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
